var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content"},[_c('span',{staticStyle:{"font-size":"32px"}},[_vm._v("总访问量："),_c('span',{staticStyle:{"color":"#E6A23C"}},[_vm._v(_vm._s(_vm.webcount.webCount))]),_vm._v("，今日访问量："),_c('span',{staticStyle:{"color":"#E6A23C"}},[_vm._v(_vm._s(_vm.webcount.userCount))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }